import { fetch } from "src/services/apollo-fetch";
import { Mutation, Query } from "../_api";

export default {
    async fetchDeliveryRequest({ commit }, id) {
        const response = await fetch.query({
            query: Query.deliveryRequest,
            variables: { id },
        });
        commit("setSelectedDeliveryRequest", response.data.deliveryRequest);
    },
    async updateDeliveryRequest({ commit }, data) {
        const response = await fetch.mutate(
            {
                mutation: Mutation.updateDeliveryRequest,
                variables: {
                    input: data,
                },
            },
            { showToast: false },
        );
        commit("updateDeliveryRequest", response.data.updateDeliveryRequest);
        commit(
            "updateSelectedDeliveryRequest",
            response.data.updateDeliveryRequest,
        );
    },
    async addChangeRequestForDelivery({ commit }, data) {
        const response = await fetch.mutate(
            {
                mutation: Mutation.addChangeRequestForDelivery,
                variables: {
                    input: data,
                },
            },
            { showToast: false },
        );
        commit(
            "updateDeliveryRequest",
            response.data.addChangeRequestForDelivery,
        );
        commit(
            "updateSelectedDeliveryRequest",
            response.data.addChangeRequestForDelivery,
        );
    },
};
